import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { setDeleteInvoiceAttachment } from '../services/setDeleteInvoiceAttachment';

export const deleteInvoiceAttachment = createAsyncThunk(
  'saleInvoices/deleteInvoiceAttachment',
  async (params, { getState }) => {
    const { invoiceId, attachmentId } = params;

    if (!invoiceId || !attachmentId) {
      throw new Error('No invoice id or attachment id provided');
    }

    const selectedProjectId = selectSelectedProjectId(getState());

    const response = await setDeleteInvoiceAttachment(
      selectedProjectId,
      invoiceId,
      attachmentId
    );

    return response;
  }
);
